import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, Event, NavigationEnd } from "@angular/router";
import { ToastService } from "./core/services/toast.service";
import { LoadingService } from "./core/services/loading.service";
import { TranslateService } from "@ngx-translate/core";
import { IWService } from "./core/services/iw.service";
import { AppConfigService } from "./app-config.service";


@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  @ViewChild("wallet", { static: true })
  currentLanguage: string;

  constructor(
    public loadingService: LoadingService,
    private router: Router,
    public toastService: ToastService,
    private iwService: IWService,
    public translate: TranslateService,
    private config: AppConfigService
  ) {
    
    console.log('CONFIG LOADED:', this.config.settings);
    console.log('API URL:', this.config.settings.apiURL);

    if (this.translate.currentLang == undefined) {
      var localLanguage = localStorage.getItem("language");
      if (localLanguage === undefined) {
        this.translate.use("es");
      } else {
        this.translate.use(localLanguage);
      }
    }

    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.toastService.clear();
      }
    });
  }

    async ngOnInit(): Promise<void> {
     await this.iwService.init();
     await this.iwService.handshake(this.translate.currentLang);
  }

  ngAfterViewInit() {}
}
